/* Azar Group — free-gift auto-add (INGCO September 2026 offer)

   Shopify's automatic BXGY discounts the gift only once it is already in the
   cart; it never puts it there. Without this, a customer adds the kit, checks
   out, and receives no hammer despite what the product page promises.

   Rather than firing a second add-to-cart request after the first (which leaves
   the cart drawer showing stale contents), this rewrites the outgoing request so
   both lines are added together. The theme's own response handling then renders
   the correct cart with no further work.

   Fails open: any error here falls through to the original request, so a bug in
   this file can never stop someone buying. */

(function () {
  var cfg = window.AZAR_OFFER;
  if (!cfg || !cfg.kitVariantId || !cfg.giftVariantId || typeof window.fetch !== 'function') return;

  var kitId = String(cfg.kitVariantId);
  var giftId = String(cfg.giftVariantId);
  var ADD = /\/cart\/add(\.js)?(\?|$)/;

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  /* Does this add-to-cart carry the kit, and not already the gift? */
  function kitOnly(fd) {
    var ids = fd.getAll('id').map(String);
    for (var pair of fd.entries()) {
      if (/^items\[\d+\]\[id\]$/.test(pair[0])) ids.push(String(pair[1]));
    }
    return ids.indexOf(kitId) !== -1 && ids.indexOf(giftId) === -1;
  }

  /* Rebuild as a multi-item payload, preserving the section-rendering params
     the theme relies on to refresh the drawer. */
  function withGift(fd) {
    var out = new FormData();
    var qty = fd.get('quantity') || '1';
    out.append('items[0][id]', kitId);
    out.append('items[0][quantity]', String(qty));
    out.append('items[1][id]', giftId);
    out.append('items[1][quantity]', '1');
    ['sections', 'sections_url', 'form_type', 'utf8'].forEach(function (k) {
      var v = fd.get(k);
      if (v !== null) out.append(k, v);
    });
    return out;
  }

  var original = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (ADD.test(urlOf(input)) && init && init.body instanceof FormData && kitOnly(init.body)) {
        var patched = {};
        for (var k in init) patched[k] = init[k];
        patched.body = withGift(init.body);
        /* Content-Type must stay unset so the browser writes the multipart boundary. */
        return original.call(this, input, patched);
      }
    } catch (e) {
      /* fall through to the untouched request */
    }
    return original.apply(this, arguments);
  };
})();
